import cc from 'classcat';
import Head from 'next/head';

import { PAGE_TITLE } from '../config';
import css from './404.module.scss';
import Image from '../components/Image';
import Layout from '../components/Layout';

const imageRoot = 'https://cdn.ov.app/media/ov/';

const sizes = [
  { size: 1656, minWidth: 1001 },
  { size: 1000, minWidth: 601 },
  { size: 600, minWidth: 376 },
  { size: 375, minWidth: 0 },
];
// eslint-disable-next-line react/prop-types
const FourOhFour = () => (
  <Layout>
    <Head>
      <title key="title">Not Found - {PAGE_TITLE}</title>
    </Head>
    <div className={css.hero}>
      <div className={css.text}>
        <h1 className={css.title}>Looks like you’ve hit a dead end.</h1>
        <p className={css.copy}>
          <span>The page you’re looking for doesn’t exist. </span>
          <span>Might we suggest a reroute?</span>
        </p>
      </div>
      <Image
        alt="People Running Over Sand Dunes"
        className={cc([css.image])}
        src={`${imageRoot}ecomm_404_desktop.jpg`}
        sizes={sizes}
        width={1656}
      />
      <Image
        alt="People Running Over Sand Dunes"
        className={cc([css.image, css.mobile])}
        src={`${imageRoot}404_-_Mobile_-_Large.jpg`}
        sizes={[
          { size: 500, minWidth: 376 },
          { size: 375, minWidth: 0 },
        ]}
        width={375}
      />
    </div>
  </Layout>
);

export default FourOhFour;
